import firebase from 'firebase/app';
require('firebase/firestore');
require('firebase/auth');
require('firebase/storage');

var config = {
  apiKey: 'AIzaSyB1v9oFqjVcMM3gk41JU6zHQO3iqv8urgU',

  authDomain: 'optionsgeek-a9749.firebaseapp.com',
  databaseURL: 'https://optionsgeek-a9749.firebaseio.com',
  projectId: 'optionsgeek-a9749',
  storageBucket: 'optionsgeek-a9749.appspot.com',
  messagingSenderId: '999798786111',
  appId: '1:999798786111:web:82a760ea0b7fee5dff908a',
  measurementId: 'G-VZFQKBB9L3',
};
var fire = firebase.initializeApp(config);
const firestore = fire.firestore();
// const fireauth = fire.auth();
firestore.settings({
  timestampsInSnapshots: true,
});
const auth = fire.auth();
const storage = fire.storage();

auth.onAuthStateChanged(function (user) {
  if (user) {
    // User is signed in.
  } else {
    firebase
      .auth()
      .signInAnonymously()
      .catch(function (error) {
        // Handle Errors here.
        // var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorMessage);
      });
  }
});

export { firestore, auth, storage };
// export default fire;



// WEBPACK FOOTER //
// ./src/fire.js